export const documentation = "https://docs.google.com/document/d/1MoixDgQ2mYQ7cNSD0AdxTPY8BCLqcJ6Uf3oiNFcrpCk/edit?usp=sharing"
export const PAYMENT_INTENT = "paymentIntent"
export const INITIATED_CHECKOUT_FLAG = 'checkout_initiated';